import { RuleEngineState } from '../models/RuleEngineState';

export const validateRuleEngineState = (state: RuleEngineState) => {
  if (!state.ruleGroups) return true;

  const isValid = state.ruleGroups.every((ruleGroup) => {
    if (ruleGroup.rules.length === 0) {
      return false;
    }
    return ruleGroup.rules.every((rule) => rule.property && rule.operator && rule.value && rule.value !== '[]');
  });
  return isValid;
};
